'use client';

import { TooltipProvider } from '@radix-ui/react-tooltip';
import ReactQueryClientProvider from './react-query-client-provider';
const Providers = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <ReactQueryClientProvider data-sentry-element="ReactQueryClientProvider" data-sentry-component="Providers" data-sentry-source-file="providers.tsx">
      <TooltipProvider data-sentry-element="TooltipProvider" data-sentry-source-file="providers.tsx">{children}</TooltipProvider>
    </ReactQueryClientProvider>;
};
export default Providers;